import classNames from "classnames";
import React, { FC } from "react";
import { styles } from "./scroll-box.scss";


export const ScrollBox: FC<{ children: React.ReactNode; }> =
    ({ children }) =>
    {
        return (
            <div className={classNames(styles.scrollBox)}>
                {children}
            </div>
        );
    };
